export default __webpack_public_path__ + "static/media/blog3.f230a1e5.png";